module.exports = __webpack_public_path__ + "manageStatic/img/logo_web.6dd678a1.png";